import React from "react";
import NationalCountryDropdown from "./NationalCountryDropdown";
import FranchiseCountryDropdown from "./FranchiseCountryDropdown";

const OwnBusiness = () => (
  <>
    {/* Hero Section */}
    <section
      className="relative text-white min-h-[80vh] flex items-center justify-center overflow-hidden"
      style={{
        background:
          "linear-gradient(90deg, rgba(252, 53, 236, 1) 0%, rgba(237, 0, 170, 1) 100%)",
      }}
    >
      <div
        className="absolute inset-0 bg-cover bg-center opacity-30"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1616692474781-9ef0114c15b1?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80')",
        }}
      ></div>

      <div className="relative z-10 text-center px-4 sm:px-6 max-w-5xl">
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold tracking-tight font-[Aeonik] leading-tight">
          OWN A BUSINESS
        </h1>
      </div>
    </section>

    {/* Business Ownership Section */}
    <div className="max-w-5xl mx-auto py-16 px-6 text-gray-800">
      <h2 className="text-3xl font-extrabold mb-6 text-main-pink">
        Two Ways to Become a Business Owner
      </h2>

      <p className="text-base leading-relaxed mb-4">
        <strong>1. Own a National Company</strong>
        <br />
        The Women of the World, Inc., as a corporate policy will sell 80% of
        shares in each company with an 80%-20% ratio. It will retain this 20% as
        the mother company and a service provider.{" "}
      </p>

      <NationalCountryDropdown />

      <p className="text-base leading-relaxed mb-6 mt-4">
        <strong>2. Own a City Franchise</strong>
        <br />
        You can independently own your city franchise and avail our exclusive
        business perks and backend support. Just buy a page and establish your
        business. We will do the rest. You can buy as many pages for your
        services, products and ideas as you like.
      </p>

      <FranchiseCountryDropdown />
      <h3 className="text-2xl font-bold text-main-pink mb-4 mt-10">
        What’s Included
      </h3>
      <ul className="list-disc list-inside text-base leading-relaxed mb-8 space-y-2">
        <li>Company registration under Women of the World Holdings, Inc.</li>
        <li>Ownership of, e.g., Women of The United Arab Emirates, Inc.</li>
        <li>Full back-end access to the Pink Help platform for your country</li>
        <li>Onboarding and legal documentation</li>
        <li>
          1-month business training from the Institute of Public Companies (with
          certification)
        </li>
        <li>
          Official founder recognition on Pink Help and Women of the World HQ
        </li>
      </ul>

      <h3 className="text-2xl font-bold text-main-pink mb-4 mt-10">
        Your Role as a National Owner
      </h3>
      <ul className="list-disc list-inside text-base leading-relaxed space-y-2">
        <li>
          Franchise out category pages (e.g., Health, Legal, Jobs, Fashion)
        </li>
        <li>Franchise by city or region (e.g., Nairobi, Paris, Karachi)</li>
        <li>Onboard advertisers and e-commerce vendors</li>
        <li>Appoint ambassadors, moderators, and partners</li>
        <li>Lead women-focused economic development across your nation</li>
        <li>
          Earn revenue from listings, partnerships, training, and product access
        </li>
      </ul>
    </div>
  </>
);

export default OwnBusiness;
